/* ===========================================================
   Area S51 — Händlersuche (harmonisiert, neuer Flow)
   PLZ-first → Werkstatt + Online-Ersatzteile + weitere (gruppiert)
   =========================================================== */
"use strict";

const CATS = [
  { key: "werkstatt",        ico: "🔧", label: "Werkstatt & Reparatur", group: "hero",    pred: f => f.workshop || f.vehiclerepairs },
  { key: "online_shops", ico: "🛒", label: "Simson Onlineshops", group: "hero", online: true, pred: f => f.onlineshopavailable },
  { key: "fahrzeughaendler", ico: "🏍️", label: "Fahrzeughändler", group: "Kaufen",       pred: f => f.vehicletrade },
  { key: "fanartikel",       ico: "🏁", label: "Fanartikel & Zubehör", group: "Kaufen",   pred: f => f.simsonfanarticles },
  { key: "motorservice",     ico: "🛡️", label: "Autorisierter Motorservice", group: "Service", pred: f => f.servicepoint },
  { key: "tuev",             ico: "📋", label: "TÜV-Abnahme", group: "Service",            pred: f => f.mot },
  { key: "abholservice",     ico: "🚚", label: "Hol- & Bringservice", group: "Service",    pred: f => f.abholservice },
  { key: "tuning",           ico: "⚡", label: "Tuning", group: "Spezial",                 pred: f => f.tuning },
  { key: "restauration",     ico: "🛠️", label: "Restauration & Aufbau", group: "Spezial",  pred: f => f.vehiclestructure },
  { key: "lackierung",       ico: "🎨", label: "Lackierung & Oberflächen", group: "Spezial", pred: f => f.vehiclepainting || f.powdercoating || f.sandblasting || f.polishing || f.foiling || f.chromeplating },
  { key: "tank",             ico: "⛽", label: "Tankrestauration", group: "Spezial",       pred: f => f.tankregeneration },
  { key: "sattler",          ico: "🪑", label: "Sattler & Sitzbänke", group: "Spezial",    pred: f => f.saddlerwork },
  { key: "vape",             ico: "🔌", label: "VAPE / Powerdynamo", group: "Spezial",     pred: f => f.prempartvapepowerdyn },
];
const CAT = Object.fromEntries(CATS.map(c => [c.key, c]));
const GROUPS = ["Kaufen", "Service", "Spezial"];

// Shopify-Config (in der Section via Liquid injiziert); lokaler Fallback fürs Prototyping
const CFG = window.ARES51_CONFIG || {};
const DATA = {
  dealers: CFG.dealers || "swhv-dealers.json",
  plz: CFG.plz || "swhv-plz.json",
  picks: CFG.picks || "swhv-picks.json",
};
const LOGO_BASE = CFG.logoBase || "";

let DEALERS = [], PLZ = {}, PICKS = {};
const root = document.getElementById("a51");
const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const slug = s => String(s).toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");

// ---- votes (DEMO: localStorage + seeded baseline.  PROD: tallies on dealer-metaobjects, written via App-Proxy → serverless, 1/device + IP rate-limit) ----
const VOTES = JSON.parse(localStorage.getItem("a51_votes") || "{}");
const hashId = id => { const s = String(id); let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; return h; };
const seedUp = id => (hashId(id) % 38) + 4;
const seedDown = id => (hashId(id) % 14);
const getV = id => VOTES[id] || { up: seedUp(id), down: seedDown(id), mine: 0 };
const vScore = id => { const v = getV(id); return v.up - v.down; };
const saveVotes = () => localStorage.setItem("a51_votes", JSON.stringify(VOTES));
function votePill(id) {
  const v = getV(id), s = v.up - v.down;
  return `<div class="vote" id="v${id}" title="Empfehlung der Community">
    <button class="vb up ${v.mine>0?"on":""}" aria-label="Empfehlen" onclick="A51.vote(${id},1)">▲</button>
    <span class="vscore ${s>0?"pos":s<0?"neg":""}">${s>0?"+":""}${s}</span>
    <button class="vb down ${v.mine<0?"on":""}" aria-label="Nicht empfehlen" onclick="A51.vote(${id},-1)">▼</button>
  </div>`;
}

function haversine(a, b) {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const R = 6371, r = x => x * Math.PI / 180;
  const dLa = r(b.lat - a.lat), dLo = r(b.lng - a.lng);
  const s = Math.sin(dLa/2)**2 + Math.cos(r(a.lat))*Math.cos(r(b.lat))*Math.sin(dLo/2)**2;
  return Math.round(2 * R * Math.asin(Math.sqrt(s)));
}
const DAYS = ["Mo","Di","Mi","Do","Fr","Sa","So"];
function openNow(h) {
  if (!h) return null;
  const n = new Date(), i = (n.getDay()+6)%7, t = h[i];
  if (!t) return { open:false, txt:"Heute geschlossen" };
  const m = String(t).match(/(\d{1,2}):(\d{2})\D+(\d{1,2}):(\d{2})/);
  if (!m) return null;
  const cur = n.getHours()*60+n.getMinutes(), f=+m[1]*60+ +m[2], to=+m[3]*60+ +m[4], open = cur>=f&&cur<=to;
  return { open, txt: (open?"Jetzt geöffnet":"Geschlossen")+" · "+DAYS[i]+" "+t };
}

// ---- pinned (featured) resolution ----
function pinnedFor(catKey, coords) {
  const af = PICKS.alwaysFirst && PICKS.alwaysFirst[catKey];
  if (af) {
    const obj = (typeof af === "string") ? (af === "ares51" ? PICKS.areaS51 : PICKS[af]) : null;
    const d = obj ? { ...obj, _ares51: true, services: obj.services || [], flags: {} }
                  : DEALERS.find(x => x.id === af);
    if (d) return { d: { ...d, dist: coords && d.lat != null ? haversine(coords, d) : null }, reason: "always" };
  }
  if (coords && !CAT[catKey].online) {
    const ids = (PICKS.recommended && PICKS.recommended[catKey]) || [];
    const c = DEALERS.filter(x => ids.includes(x.id) && CAT[catKey].pred(x.flags))
      .map(x => ({ ...x, dist: haversine(coords, x) }))
      .filter(x => x.dist != null && x.dist <= (PICKS.recommendRadiusKm || 100))
      .sort((a, b) => a.dist - b.dist);
    if (c.length) return { d: c[0], reason: "recommended" };
  }
  return null;
}
function rank(catKey, coords, bl) {
  const cat = CAT[catKey];
  let pool = DEALERS.filter(d => cat.pred(d.flags));
  if (bl) pool = pool.filter(d => slug(d.bl) === bl);
  const pin = pinnedFor(catKey, coords);
  let list = pool.map(d => ({ ...d, dist: coords ? haversine(coords, d) : null }));
  if (pin && pin.d && typeof pin.d.id === "number") list = list.filter(d => d.id !== pin.d.id);
  if (cat.online) list.sort((a, b) => vScore(b.id) - vScore(a.id) || a.name.localeCompare(b.name, "de"));
  else if (coords) {
    // distance primary, votes boost: a well-rated dealer counts as up to 18 km "closer"
    const eff = d => Math.max(0, (d.dist ?? 1e9) - Math.min(18, Math.max(0, vScore(d.id) * 1.5)));
    list.sort((a, b) => eff(a) - eff(b));
  } else list.sort((a, b) => a.name.localeCompare(b.name, "de"));
  return { pin, list, total: pool.length };
}

// ---- pieces ----
function logo(d) {
  const raw = d.logo || "";
  let src = "";
  if (raw) src = /^(https?:|\/\/)/.test(raw) ? raw : (LOGO_BASE ? LOGO_BASE + raw : "");
  if (src) return `<img class="logo" src="${esc(src)}" alt="${esc(d.name)} Logo" loading="lazy" onerror="this.className='logo ph';this.removeAttribute('src');this.textContent='${esc((d.name[0]||'S').toUpperCase())}'">`;
  return `<div class="logo ph">${esc((d.name[0]||"S").toUpperCase())}</div>`;
}
function icons(d) {
  const o = [];
  if (d.phone) o.push(`<a class="ic" href="tel:${esc(d.phone.replace(/\s/g,""))}" title="Anrufen">☎</a>`);
  if (d.email) o.push(`<a class="ic" href="mailto:${esc(d.email)}" title="E-Mail">✉</a>`);
  if (d.website) o.push(`<a class="ic" href="${esc(d.website)}" target="_blank" rel="noopener" title="Webseite">🌐</a>`);
  if (!CAT_ONLINE_VIEW && d.lat != null) o.push(`<a class="ic" href="https://www.google.com/maps/dir/?api=1&destination=${d.lat},${d.lng}" target="_blank" rel="noopener" title="Route">📍</a>`);
  return `<div class="icons">${o.join("")}</div>`;
}
let CAT_ONLINE_VIEW = false;
const prettyUrl = u => String(u).replace(/^https?:\/\//, "").replace(/^www\./, "").replace(/\/$/, "");
function contactRow(d, online) {
  const o = [];
  if (d.phone) o.push(`<a class="cl" href="tel:${esc(d.phone.replace(/\s/g,""))}"><span class="ci">☎</span>${esc(d.phone)}</a>`);
  if (d.email) o.push(`<a class="cl" href="mailto:${esc(d.email)}"><span class="ci">✉</span>${esc(d.email)}</a>`);
  if (d.website) o.push(`<a class="cl web" href="${esc(d.website)}" target="_blank" rel="noopener"><span class="ci">🌐</span>${esc(prettyUrl(d.website))}</a>`);
  if (!online && d.lat != null) o.push(`<a class="cl" href="https://www.google.com/maps/dir/?api=1&destination=${d.lat},${d.lng}" target="_blank" rel="noopener"><span class="ci">📍</span>Route</a>`);
  return o.length ? `<div class="c-contact">${o.join("")}</div>` : "";
}
function tags(d, online) {
  const all = (d.services || []).filter(s => !/online/i.test(s));
  const t = [];
  if (d.flags && d.flags.onlineshopavailable) t.push(`<span class="tag on">Online-Shop</span>`);
  all.slice(0, 3).forEach(s => t.push(`<span class="tag">${esc(s)}</span>`));
  const extra = all.length - 3;
  if (extra > 0) t.push(`<span class="tag more">+${extra}</span>`);
  return t.length ? `<div class="c-tags">${t.join("")}</div>` : "";
}
function distEl(d, online) {
  if (online || d.nationwide) {
    if (d.nationwide) return `<div class="dist online">deutschlandweit</div>`;
    return `<div class="dist online">Online-Shop</div>`;
  }
  if (d.dist == null) return "";
  return `<div class="dist">≈ ${d.dist}<small> km</small></div>`;
}
function card(d, online, rank) {
  const on = !online && openNow(d.hours);
  return `<article class="card">
    <div class="c-rank">${rank != null ? (rank < 10 ? "0" + rank : rank) : ""}</div>
    ${logo(d)}
    <div class="c-main">
      <div class="c-name">${esc(d.name)}</div>
      <div class="c-addr">${esc(d.street)} · ${esc(d.zip)} ${esc(d.city)}${d.bl?` · ${esc(d.bl)}`:""}</div>
      ${contactRow(d, online)}
      ${tags(d, online)}
      ${on ? `<div class="open ${on.open?"y":"n"}">${esc(on.txt)}</div>` : ""}
    </div>
    <div class="c-side">${distEl(d, online)}${votePill(d.id)}</div>
  </article>`;
}
function featCard(d, reason, online) {
  const note = reason === "always"
    ? (d.tagline || (online ? "Unser Top-Shop für Simson-Ersatzteile" : "Unsere Nr. 1 Empfehlung"))
    : "Von Area S51 geprüfter Partner in deiner Region.";
  return `<article class="card feat">
    <div class="feat-strip">★ Unsere Empfehlung</div>
    <div class="feat-inner">
      ${logo(d)}
      <div class="c-main">
        <div class="c-name">${esc(d.name)}</div>
        <div class="c-addr">${d.street?esc(d.street)+" · ":""}${esc(d.zip)} ${esc(d.city)}${d.bl?` · ${esc(d.bl)}`:""}</div>
        <div class="feat-note">${esc(note)}</div>
        ${Array.isArray(d.usps) && d.usps.length ? `<div class="feat-usps">${d.usps.map(u => `<span>✓ ${esc(u)}</span>`).join("")}</div>` : ""}
        ${d.voucher ? `<div class="voucher">🎟️ Exklusiv bei Area&nbsp;S51: Code <b>${esc(d.voucher)}</b></div>` : ""}
        ${contactRow(d, online)}
        ${tags(d, online)}
      </div>
      <div class="c-side">${distEl(d, online)}${d.website?`<a class="btn-cta" href="${esc(d.website)}" target="_blank" rel="noopener">Zum Händler →</a>`:""}</div>
    </div>
  </article>`;
}
function plzChip() {
  const o = PLZ[state.plz];
  return `<span class="plz-chip" id="chip"><span class="pin">📍</span> <b>${esc(state.plz)}</b> <span class="chip-ort">${o?esc(o.ort):""}</span>
    <button class="edit" title="PLZ ändern" onclick="A51.editPlz()">✎</button></span>`;
}

// ---- kontextuelle Verlinkung in den Bestand (Shop, Guides) + Partner-CTA ----
function relatedLinks(catKey) {
  const L = PICKS.links || {};
  const sets = {
    hub:              [["Simson kaufen – Shop", L.shopMopeds], ["Ersatzteile-Shop", L.shopErsatzteile], ["S51 Konfigurator", L.konfigurator], ["S51 Kauf-Komplettguide", L.guideKauf]],
    fahrzeughaendler: [["Simson kaufen – Shop", L.shopMopeds], ["S51 Kauf-Komplettguide", L.guideKauf], ["Ratenkauf & Finanzierung", L.guideFinanzierung], ["S51 Konfigurator", L.konfigurator], ["Kennzeichen 2025", L.kennzeichen]],
    werkstatt:        [["Ersatzteile bestellen", L.shopErsatzteile], ["Rahmennummer prüfen", L.rahmennummer], ["Erste Schritte mit deiner S51", L.ersteSchritte], ["S51 winterfest machen", L.winterfest]],
    online_shops:     [["Unser Ersatzteile-Shop", L.shopErsatzteile], ["Ersatzteilliste Neuaufbauten", L.ersatzteilliste]],
    tuev:             [["Kennzeichen 2025", L.kennzeichen], ["KBA-Papiere", L.kbaPapiere], ["Warum legal 60 km/h", L.legal60]],
    restauration:     [["Mopeds & Neuaufbauten", L.shopMopeds], ["S51 Kauf-Komplettguide", L.guideKauf], ["Ersatzteilliste Neuaufbauten", L.ersatzteilliste]],
    motorservice:     [["Ersatzteile bestellen", L.shopErsatzteile], ["S51 Kauf-Komplettguide", L.guideKauf]],
  };
  const def = [["Simson kaufen – Shop", L.shopMopeds], ["Ersatzteile-Shop", L.shopErsatzteile], ["S51 Kauf-Komplettguide", L.guideKauf]];
  const items = (sets[catKey] || def).filter(x => x[1]);
  const rel = items.length
    ? `<div class="related"><div class="rel-title">Rund um Simson bei Area S51</div><div class="rel-links">${items.map(([t, u]) => `<a href="${esc(u)}">${esc(t)} →</a>`).join("")}</div></div>`
    : "";
  return rel + partnerCta();
}
function partnerCta() {
  const u = (PICKS.links || {}).partnerWerden;
  if (!u) return "";
  return `<div class="partner-cta"><div class="pc-text"><b>Du bist Händler oder Werkstatt?</b><br><span>Werde Area-S51-Partner und erscheine im Verzeichnis – auch ohne MZA-Listung.</span></div><a class="pc-btn" href="${esc(u)}">Partner werden →</a></div>`;
}

// ---------- views ----------
function viewLanding() {
  CAT_ONLINE_VIEW = false;
  root.innerHTML = `<div class="wrap land">
    <div class="eyebrow">Simson Händler-Verzeichnis</div>
    <h1>Finde deinen<br><span class="u">Simson-Stützpunkt</span></h1>
    <p class="lead">Werkstatt, Ersatzteile, Fahrzeuge & Service in deiner Nähe – gib deine Postleitzahl ein, wir sortieren nach Entfernung.</p>
    <form class="plz-hero" id="lf">
      <div class="plz-row"><span class="pin">📍</span>
        <input id="li" inputmode="numeric" maxlength="5" placeholder="Deine PLZ – z. B. 04109" autocomplete="postal-code">
        <button type="submit" aria-label="Stützpunkte finden"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg></button>
      </div>
      <div class="plz-msg" id="lm"></div>
    </form>
    <div class="alt">Suchst du nur <a href="#/k/online_shops">Simson Onlineshops</a>? Dafür brauchst du keine PLZ.</div>
    <div class="trust"><span><b>986</b> Händler in Deutschland</span><span><b>16</b> Bundesländer</span><span>Geprüfte Empfehlungen</span></div>
  </div>`;
  const f = document.getElementById("lf");
  f.addEventListener("submit", e => {
    e.preventDefault();
    const v = document.getElementById("li").value.trim();
    const lm = document.getElementById("lm");
    lm.textContent = "…";
    ensureData().then(() => {
      if (!PLZ[v]) { lm.textContent = "⚠ PLZ nicht gefunden – bitte 5-stellig prüfen."; return; }
      state.plz = v; save(); lm.textContent = ""; location.hash = "#/"; route();
    }).catch(dataErr);
  });
  document.getElementById("li").focus();
}

function block(title, locBadge, innerHtml, moreHref, moreLabel) {
  return `<section class="block"><div class="block-head">
      <h3>${esc(title)} ${locBadge?`<span class="badge-loc">${esc(locBadge)}</span>`:""}</h3>
      ${moreHref?`<a class="more" href="${moreHref}">${esc(moreLabel)} →</a>`:""}
    </div>${innerHtml}</section>`;
}

function viewHub() {
  CAT_ONLINE_VIEW = false;
  const coords = PLZ[state.plz];
  // ① Werkstatt
  const w = rank("werkstatt", coords);
  let wHtml = `<div class="list">`;
  if (w.pin) wHtml += featCard(w.pin.d, w.pin.reason, false);
  wHtml += w.list.slice(0, 3).map((d, i) => card(d, false, i + 1)).join("") + `</div>`;
  // ② Online-Ersatzteile
  CAT_ONLINE_VIEW = true;
  const o = rank("online_shops", null);
  let oHtml = `<div class="list">`;
  if (o.pin) oHtml += featCard(o.pin.d, o.pin.reason, true);
  oHtml += o.list.slice(0, 5).map((d, i) => card(d, true, i + 1)).join("") + `</div>`;
  CAT_ONLINE_VIEW = false;
  // ③ groups
  const groupsHtml = GROUPS.map(g => {
    const tiles = CATS.filter(c => c.group === g).map(c => {
      const n = DEALERS.filter(d => c.pred(d.flags)).length;
      return `<a class="tile" href="#/k/${c.key}"><span class="ti">${c.ico}</span><span><span class="tt">${esc(c.label)}</span><br><span class="tc">${n} Stützpunkte</span></span></a>`;
    }).join("");
    return `<div class="grp"><div class="grp-label">${esc(g)}</div><div class="tiles">${tiles}</div></div>`;
  }).join("");

  root.innerHTML = `<div class="wrap res">
    <div class="res-bar"><h2 class="page">Deine Simson-Stützpunkte</h2>${plzChip()}</div>
    ${block("Werkstatt in deiner Nähe", "nach Entfernung", wHtml, "#/k/werkstatt", `Alle ${w.total} Werkstätten`)}
    ${block("Simson Onlineshops", "ohne PLZ – deutschlandweit", oHtml, "#/k/online_shops", `Alle ${o.total} Shops`)}
    ${block("Weitere Leistungen", "", `<div class="groups">${groupsHtml}</div>`)}
    ${relatedLinks("hub")}
  </div>`;
}

function viewCategory(key, bl) {
  const cat = CAT[key];
  if (!cat) { location.hash = "#/"; return; }
  const online = !!cat.online;
  CAT_ONLINE_VIEW = online;
  const coords = online ? null : PLZ[state.plz];
  const { pin, list, total } = rank(key, coords, bl);

  // region links (Bundesländer with dealers in this category)
  const blCounts = {};
  DEALERS.filter(d => cat.pred(d.flags)).forEach(d => { if (d.bl) blCounts[d.bl] = (blCounts[d.bl]||0)+1; });
  const regions = Object.entries(blCounts).sort((a,b)=>b[1]-a[1])
    .map(([name,n]) => `<a href="#/k/${key}/${slug(name)}" ${slug(name)===bl?'style="border-color:var(--red);color:var(--red)"':""}>${esc(name)} (${n})</a>`).join("");

  const blName = bl ? (Object.keys(blCounts).find(n => slug(n)===bl) || bl) : "";
  const crumb = `<div class="crumb"><a href="#/">Start</a> › <a href="#/">Händlersuche</a> › ${bl?`<a href="#/k/${key}">${esc(cat.label)}</a> › ${esc(blName)}`:esc(cat.label)}</div>`;
  const title = bl ? `${cat.label} in ${blName}` : cat.label;

  let body = "";
  if (!online && !coords) body += `<div class="notice">Gib deine <b>PLZ</b> oben ein – dann sortieren wir die ${total} Einträge nach Entfernung und zeigen unsere Empfehlung in deiner Nähe.</div>`;
  let html = `<div class="list">`;
  if (pin) html += featCard(pin.d, pin.reason, online);
  html += (online ? "" : "");
  const shown = list.slice(0, 60);
  html += shown.map((d, i) => card(d, online, i + 1)).join("") + `</div>`;
  if (list.length > shown.length) html += `<div class="notice" style="margin-top:12px">+ ${list.length - shown.length} weitere – mit PLZ verfeinern.</div>`;
  body += html;

  root.innerHTML = `<div class="wrap res">
    ${crumb}
    <div class="res-bar"><h2 class="page">${esc(title)}</h2>${online?"":plzChip()}</div>
    <div style="color:var(--muted);font-size:14px;margin:-2px 0 8px">${total} Einträge${bl?` in ${esc(blName)}`:""}${online?" · deutschlandweit, ohne PLZ":coords?` · rund um ${esc(state.plz)}`:""}</div>
    ${body}
    <div class="regionbar"><div class="rl-title">${esc(cat.label)} nach Bundesland</div><div class="reglinks">${regions}</div></div>
    ${relatedLinks(key)}
  </div>`;
}

// ---------- change-PLZ inline ----------
const A51 = {
  vote(id, dir) {
    const v = getV(id);
    if (v.mine === dir) { if (dir > 0) v.up--; else v.down--; v.mine = 0; }
    else { if (v.mine > 0) v.up--; else if (v.mine < 0) v.down--; if (dir > 0) v.up++; else v.down++; v.mine = dir; }
    VOTES[id] = v; saveVotes();
    const el = document.getElementById("v" + id);
    if (el) el.outerHTML = votePill(id);
  },
  editPlz() {
    const chip = document.getElementById("chip");
    if (!chip) return;
    chip.outerHTML = `<form id="cf" class="plz-chip" style="padding-left:10px">
      <span class="pin">📍</span><input id="ci" inputmode="numeric" maxlength="5" value="${esc(state.plz)}" style="border:0;outline:0;font:inherit;width:90px;background:transparent">
      <button class="edit" type="submit" title="OK">✓</button></form>`;
    const ci = document.getElementById("ci"); ci.focus(); ci.select();
    document.getElementById("cf").addEventListener("submit", e => {
      e.preventDefault();
      const v = ci.value.trim();
      if (PLZ[v]) { state.plz = v; save(); route(); } else ci.style.color = "var(--red)";
    });
  }
};
window.A51 = A51;

// ---------- state ----------
const state = { plz: localStorage.getItem("a51_plz") || "" };
function save() { localStorage.setItem("a51_plz", state.plz || ""); }

// ---------- Daten lazy laden (blockiert NICHT den ersten Render / LCP) ----------
let _dataP = null;
function ensureData() {
  if (_dataP) return _dataP;
  _dataP = Promise.all([
    fetch(DATA.dealers).then(r => r.json()),
    fetch(DATA.plz).then(r => r.json()),
    fetch(DATA.picks).then(r => r.json()),
  ]).then(([d, p, pk]) => {
    DEALERS = Array.isArray(pk.customDealers) && pk.customDealers.length ? d.concat(pk.customDealers) : d;
    PLZ = p; PICKS = pk;
  });
  return _dataP;
}
function dataErr(e) { root.innerHTML = `<div class="wrap"><div class="notice">Daten konnten nicht geladen werden: ${esc(e.message)}</div></div>`; }

// ---------- router ----------
function route() {
  const h = location.hash.replace(/^#/, "");
  const m = h.match(/^\/k\/([a-z_]+)(?:\/([a-z-]+))?/);
  if (m) { ensureData().then(() => viewCategory(m[1], m[2] || null)).catch(dataErr); return; }
  if (state.plz) { ensureData().then(() => { PLZ[state.plz] ? viewHub() : viewLanding(); }).catch(dataErr); return; }
  viewLanding();
  ensureData().catch(() => {}); // im Hintergrund vorladen für schnelle erste Suche
}

// ---------- boot ----------
const _q = new URLSearchParams(location.search).get("plz");
if (_q && /^\d{5}$/.test(_q)) { state.plz = _q; save(); }
window.addEventListener("hashchange", route);
route();
